/* eslint-disable */ import { memoEval, sceneEntityAddFabComponent, sceneEntityPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const noCabinetComponents = [
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('NoCabinet').attach(memoEval((self)=>[
            self.offsetX
        ], (offsetX)=>({
            offsetX: offsetX
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addWallFab', true).withAlias('NoCabinet').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$noWallCabinetAbove
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 12,
            offsetY: 70,
            offsetZ: 12,
            instanceNames: [
                'wallCabinetAbove'
            ],
            skipMenuWhenOnlyOne: true,
            hideWhenNone: true,
            showWhen: [
                'selected',
                'unselected'
            ],
            polarAngleLimits: {
                min: 1.4,
                max: 1.7
            },
            azimuthAngleLimits: {
                min: -0.5,
                max: 0.5
            }
        })))
];

//# sourceMappingURL=no-cabinet.js.map